import React, { useRef, useState } from "react";
import * as Fa from "react-icons/fa";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { fetchData } from "../../../Services/GlobalService";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import { downloadExcel } from "../../../Services/GlobalFunction/DownLoadExcel";
import { AxiosExcel } from "../../../API/Axios";
import Loader from "../../../Components/Loader";

const FORMAT_LIST = [
  { label: "xlsx", value: "xlsx" },
  { label: "csv",  value: "csv"  },
];

const ThresholdRestriction: React.FC = () => {
  const UserId    = localStorage.getItem("UserId")?.toString();
  const getformat = GetDateFormat();

  const BaseUrl = "DBScoreCard/ThresholdRestriction";
  const Endpoint = {
    UploadFile: "ThresholdUpload",
    ExportFile: "ExportThresholdData",
  };

  const fileUploadRef = useRef<FileUpload>(null);

  /* ── State ── */
  const [loader,         setLoader]         = useState<boolean>(false);
  const [exportLoading,  setExportLoading]  = useState<boolean>(false);
  const [templateFormat, setTemplateFormat] = useState<string>("xlsx");

  /* ── Download Template ── */
  const handleDownloadTemplate = () => {
    const headers = [{ "DB Code": null, "Threshold %": null }];
    downloadExcel(headers, `Threshold_Restriction_Template_${getformat}.${templateFormat}`);
  };

  /* ── Export ── */
  const handleExport = async () => {
    setExportLoading(true);
    try {
      const res = await fetchData(BaseUrl, Endpoint.ExportFile, "");
      if (res?.Data?.length > 0) {
        downloadExcel(res.Data, `Threshold_Restriction_${getformat}.xlsx`);
      } else {
        toast.error("No Data Found");
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Export failed");
    } finally {
      setExportLoading(false);
    }
  };

  /* ── File Upload ── */
  const handleFileUpload = async (event: any) => {
    setLoader(true);
    try {
      const file = event.files[0];
      const formData = new FormData();
      formData.append("PvcUserid",   UserId ?? "");
      formData.append("FileContent", file);

      const response = await AxiosExcel.post(
        `${BaseUrl}/${Endpoint.UploadFile}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const res = response.data;
      if (res.Status === "Success") {
        toast.success(res.Message);
        fileUploadRef.current?.clear();
      } else if (res.Status === "ErrorFR") {
        toast.warn(res.message);
        fileUploadRef.current?.clear();
      } else if (res.Status === "Error") {
        toast.warn(res.message);
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.message ?? "Upload failed");
      fileUploadRef.current?.clear();
    } finally {
      setLoader(false);
    }
  };

  if (loader) return <Loader />;

  return (
    <main>
      <div className="col-12 mb-5">

        {/* ── Breadcrumb ── */}
        <div className="col-lg-12 col-md-12 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mx-0">
              <li className="breadcrumb-item">DB SIP</li>
              <li className="breadcrumb-item active" aria-current="page">
                Threshold Restriction
              </li>
            </ol>
          </nav>
        </div>

        {/* ── Page title + action buttons ── */}
    <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-12">
                <h3 className="py-2">Threshold Restriction</h3>
              </div>
              <div className="col-lg-8 col-md-12 col-sm-12">
                <div className="text-end">
                  <div className="d-inline-flex">
                    <Dropdown
                      value={templateFormat}
                      onChange={(e) => setTemplateFormat(e.value)}
                      options={FORMAT_LIST}
                      optionLabel="label"
                      style={{
                        width: 100,
                        borderRadius: "0 6px 6px 0",
                        border: "1px solid #ced4da",
                        borderLeft: "none",
                        height: "100%",
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn anime-secondary-btn mx-2"
                    onClick={handleDownloadTemplate}
                  >
                    Download Template <Fa.FaDownload className="ms-2" />
                  </button>
                  <button
                    type="button"
                    className="btn anime-btn"
                    onClick={handleExport}
                    disabled={exportLoading}
                  >
                    {exportLoading ? (
                      <>
                        Exporting...{" "}
                        <span className="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true" />
                      </>
                    ) : (
                      <>Export <Fa.FaFileExport className="ms-2" /></>
                    )}
                  </button>
                </div>
              </div>
            </div>

        <section className="sales-box">
          {/* ── Upload section ── */}
          <div className="row d-flex justify-content-end align-items-end mt-3">
            <div className="col-lg-7 col-md-7 col-sm-12">
              <div className="UploadSection clearfix">
                <div className="conText">
                  <Fa.FaInfoCircle className="icon" /> Select an Excel or CSV File to upload
                </div>
                <FileUpload
                  ref={fileUploadRef}
                  className="clearfix nTopMargin"
                  name="demo[]"
                  accept=".xlsx, .xls, .csv"
                  emptyTemplate={
                    <p className="m-0">Drag and drop files to here to upload.</p>
                  }
                  customUpload
                  uploadHandler={handleFileUpload}
                />
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12">
              <div className="text-end">
                <img
                  src={require("../../../Assets/Images/File_Upload.png")}
                  className="File_Upload_Img drop-right"
                  alt="InnoRise"
                />
              </div>
            </div>
          </div>
        </section>

      </div>
    </main>
  );
};

export default ThresholdRestriction;